import React, { useState, useEffect } from 'react';

import { Badge, Divider, Popover } from '@mui/material';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import moment from 'moment';
import DeleteIcon from '@mui/icons-material/Delete';
import { cloneDeep } from 'lodash';
import { socketData } from '../../hooks/network/useSocketAPI';
import { notificationToaster } from '../toaster/Toaster';
import DocumentIcon from '../../assets/svg/DocumentIcon';
import useNotificationAPI from '../../hooks/network/useNotificationAPI';
import NiceLogo from '../../assets/svg/NiceLogo';

function Notification2() {
  const [notificationData, setNotificationData] = useState([]);
  const [event, setEvent] = useState(false);
  const [showNotification, setShowNOtification] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notificationCount, setNotificationCount] = useState(0);

  const { getNotifications, deleteNotifications, readNotification } = useNotificationAPI();

  useEffect(() => {
    fetchNotifications();
  }, []);

  socketData.subscribe((value) => {
    if (
      value?.eventName === 'notification' &&
      value.data.title &&
      value.data !== event &&
      notificationData.find((n) => n.id === value.id) === undefined
    ) {
      setEvent(value.data);
    }
  });

  useEffect(() => {
    if (event && notificationData.find((n) => n.id === event.id) === undefined) {
      const notificationPart = event.message ? ` - ${event.message}` : '';
      const notification = event.title ? `${event.title}${notificationPart}` : notificationPart;
      notificationToaster(notification);
      setNotificationData([event, ...notificationData]);
      setNotificationCount(notificationCount + 1);
    }
  }, [event]);

  const fetchNotifications = async () => {
    const oldNotifications = await getNotifications();
    setNotificationData(oldNotifications?.docs || []);
    const count = typeof oldNotifications?.count === 'number' ? oldNotifications?.count : 0;
    setNotificationCount(count);
  };

  const handleDeleteNotification = async (id, isReadNotification) => {
    try {
      await deleteNotifications({ notificationIds: [id] });
      const filteredNotifications = notificationData?.filter((f) => f.id !== id);
      setNotificationData(filteredNotifications);
      if (!isReadNotification) {
        setNotificationCount(notificationCount - 1);
      }
    } catch {}
  };

  const handleReadNotifications = async (id) => {
    try {
      const response = await readNotification({ notificationIds: [id] });
      if (response?.success) {
        const clonedNotificationsData = cloneDeep(notificationData);
        const index = clonedNotificationsData?.findIndex((f) => f.id === id);
        clonedNotificationsData[index].isRead = true;
        setNotificationData(clonedNotificationsData);
        setNotificationCount(notificationCount - 1);
      }
    } catch {}
  };

  return (
    <>
      <Badge
        badgeContent={notificationCount}
        color='error'
        onClick={(e) => {
          setShowNOtification(!showNotification);
          setAnchorEl(e.currentTarget);
        }}
        aria-describedby='notification'
      >
        <NotificationsOutlinedIcon className='text-white' />
      </Badge>

      <Popover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        id='notification'
        className=''
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        <div className='h-full max-h-[calc(100vh-150px)] min-h-[400px] w-[100vw] max-w-full break:w-[400px] maclg:w-[600px]'>
          {notificationData?.map((n, i) => (
            <div key={n?.id}>
              <div className='flex gap-4 px-8 py-5'>
                <div className='self-start rounded-full bg-nblue p-2'>
                  <NiceLogo height='20px' width='20px' />
                </div>
                <div className='w-full'>
                  <div className='font-semibold text-black'>{n?.title}</div>
                  <div className='mt-1 flex flex-wrap gap-2 text-sm text-black '>
                    <p>{n?.message}</p>
                  </div>
                  <div className='mt-1 flex flex-wrap gap-2 text-xs text-gray-400'>
                    <p>
                      {moment(n?.createdAt).format('DD/MM/YYYY LT') || ''} <span>&#8226;</span>{' '}
                      {n?.url ? (
                        <span className='cursor-pointer underline'>
                          <a target='_blank' href={n?.url} rel='noreferrer'>
                            {n?.appName || 'NICE'}
                          </a>
                        </span>
                      ) : (
                        <span> {n?.appName || 'NICE'} </span>
                      )}
                    </p>
                  </div>
                  {n?.imageURL && (
                    <div className='mt-2 flex justify-start gap-2 rounded-lg bg-[#EBF1FF] px-4 py-3'>
                      <div className='self-center'>
                        <DocumentIcon height='25px' />
                      </div>
                      <div className='w-full'>
                        <div className='text-sm'>{n?.imageURL.split('/').pop()}</div>
                        <div className='flex items-end justify-between'>
                          <div className='flex gap-2 text-[10px] text-gray-400'>
                            {/* 2.8MB <h3>&#8226;</h3> <p>2 hour. ago</p>{' '} */}
                            <p></p>
                          </div>
                          <div className='self-start rounded-sm bg-[#9CCC65] px-1.5 py-0.5 text-[10px]'>
                            <a
                              target={'_blank'}
                              download
                              href={n?.imageURL}
                              className='text-white'
                              rel='noreferrer'
                            >
                              View
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {n?.id && (
                  <div className='flex items-center justify-center gap-2'>
                    {!n?.isRead && (
                      <div
                        onClick={() => handleReadNotifications(n?.id)}
                        className='h-2 w-2 cursor-pointer rounded-full bg-nblue'
                      />
                    )}
                    <div
                      className='cursor-pointer'
                      onClick={() => handleDeleteNotification(n?.id, n?.isRead)}
                    >
                      <DeleteIcon />
                    </div>
                  </div>
                )}
              </div>
              {i !== notificationData.length - 1 && <Divider variant='inset' />}
            </div>
          ))}
        </div>
      </Popover>
    </>
  );
}

export default React.memo(Notification2);
